import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../../common/SEO';
import HeaderTwo from '../../common/header/HeaderTwo';
import BannerOne from '../../components/banner/BannerOne';
import NewsLetterFormTwo from '../../components/newsletter/NewsLetterTwo';
import FooterOne from "../../common/footer/FooterOne";
import HappyServices from "../../innerpages/HappyServices";
import ZoomableImage from "../../components/banner/ZoomableImage";
import SectionTitle from "../../components/sectionTitle/SectionTitle";
import IntegrationsCarousel from "../../components/banner/integrations";
import PremiumHomeSections from "../../components/premium/PremiumHomeSections";

const HomeThree = () => {
    const { t } = useTranslation();
    const [isBannerFullScreen, setIsBannerFullScreen] = React.useState(false);

    return (
        <>
            {!isBannerFullScreen ? <><SEO />
                <HeaderTwo styles="header-transparent header-style-1" fromHome={true}/>
                <BannerOne fromHome={true} isBannerFullScreen={isBannerFullScreen} setIsBannerFullScreen={setIsBannerFullScreen}/>
                <PremiumHomeSections />
                <SectionTitle
                    classes = "text-center pt--30 pb--60"
                    slogan = {t('homeThree.section.slogan')}
                    title = {t('homeThree.section.title')}

                />
                <HappyServices id="happy-szolgatltatasok" fromHome={true}/>

                {/*<DemoBanner/>1*/}
                {/*<ContactUs fromHome={true}/>*/}

                <IntegrationsCarousel/>
                <NewsLetterFormTwo fromHome={true}/>
                <FooterOne/></> : <ZoomableImage isBannerFullScreen={isBannerFullScreen} setIsBannerFullScreen={setIsBannerFullScreen}/>
            }
        </>
    )
}

export default HomeThree;
